// This file contains utility functions for working with Google Tag Manager and Twitter Pixel

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
        twq: (...args: any[]) => void;
    }
}

export const trackSignUpConversion = () => {
    if (window.gtag) {
        // Replace these values with what Google Ads provides
        window.gtag('event', 'conversion', {
            'send_to': 'AW-1697163703/iIfYCKHptLUaEOXC2pw_',
            // Optional values if needed:
            // 'value': 1.0,
            // 'currency': 'USD'
        });
    }
};

export const trackTwitterSignUpConversion = (eventId: string, parameters?: Record<string, any>) => {
    if (window.twq) {
        // Check if twq is the real function (not just the queue)
        const isRealTwq = window.twq.toString().includes('twq') && !window.twq.toString().includes('queue.push');
        
        if (isRealTwq) {
            // Twitter pixel is fully loaded, send event directly
            window.twq('event', eventId, parameters || {});
        } else {
            // Twitter pixel not fully loaded, queue the event
            window.twq('event', eventId, parameters || {});
        }
    } else {
        console.warn("Unable to load twitter pixel because of adblocker");
    }
};
